module.exports = __webpack_public_path__ + "img/bbc-radio-6-music.5bf8db73.png";